import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

const Task = ({ listTask }) => {
    return (
        <div className="teboil-task">
            <FullWrapper>
                <div className="teboil-taskWrapper">
                    <div className="teboil-taskTitle">Задачи проекта:</div>
                    <div className="teboil-taskItems">
                        {listTask.map((item, index) => (
                            <div className="teboil-taskItem" key={index}>
                                <div className="teboil-taskNumber">{item.number}</div>
                                <div className="teboil-taskText">{item.text}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Task;
